export function describeInventoryAudit(log) {
  const delta = log.quantityDelta;
  const action = log.action || '';

  if (action === 'BOOKING_PAYMENT_CONFIRMED') {
    return {
      title: 'Payment confirmed',
      detail:
        log.note ||
        'Payment received — reservation hold confirmed for this night'
    };
  }

  if (action === 'BOOKING_PAID_RE_RESERVE') {
    return {
      title: 'Reserved after payment',
      detail:
        typeof delta === 'number'
          ? `+${delta} unit held — payment confirmed`
          : 'Unit held after successful payment'
    };
  }

  if (action === 'BOOKING_RESERVE' || (typeof delta === 'number' && delta > 0)) {
    return {
      title: 'Reserved at checkout',
      detail:
        typeof delta === 'number'
          ? `+${delta} unit held for this night (payment not completed yet)`
          : 'Unit held while guest is on payment page'
    };
  }

  if (action === 'BOOKING_VENDOR_DECLINE') {
    return {
      title: 'Released — booking declined',
      detail:
        typeof delta === 'number'
          ? `${delta} unit · host declined this reservation`
          : 'Inventory released after host declined the booking'
    };
  }

  if (action === 'BOOKING_APPROVED_CANCEL') {
    return {
      title: 'Restocked — booking cancelled',
      detail:
        typeof delta === 'number'
          ? `${delta} unit · approved booking was cancelled`
          : log.note || 'Inventory restocked after cancellation'
    };
  }

  if (
    action === 'PAYMENT_VERIFY_NOT_PAID' ||
    action === 'BOOKING_CANCEL_RELEASE' ||
    action === 'BOOKING_RELEASE' ||
    action === 'BOOKING_USER_CANCEL' ||
    action === 'PAYMENT_CHECKOUT_ABANDON' ||
    action === 'AUTO_ABANDON_ON_AVAILABILITY_CHECK' ||
    action === 'PAYMENT_INIT_REPLACE_STALE' ||
    action === 'AUTO_ABANDON_STALE_PENDING' ||
    (typeof delta === 'number' && delta < 0)
  ) {
    return {
      title: 'Released — payment not completed',
      detail:
        typeof delta === 'number'
          ? `${delta} unit · inventory available again`
          : log.note || 'Guest left payment without paying'
    };
  }

  return { title: action, detail: log.note };
}
